<template>
  <div>
    <date-range-picker
      ref="picker"
      :opens="opens"
      :locale-data="{ firstDay: 1, format: 'yyyy-mm-dd' }"
      :minDate="minDate"
      :maxDate="maxDate"
      :singleDatePicker="singleDatePicker"
      :showWeekNumbers="showWeekNumbers"
      :showDropdowns="showDropdowns"
      :autoApply="autoApply"
      v-model="dateRange"
      @toggle="checkOpen"
      :linkedCalendars="linkedCalendars"
      :always-show-calendars="false"
      :alwaysShowCalendars="alwaysShowCalendars"
      :closeOnEsc="closeOnEsc"
      @update="updateValues"
    >
    </date-range-picker>
    <v-btn
      @click.stop="toggleModal"
    >
      Filter By Date
    </v-btn>
  </div>
</template>
<script>
import DateRangePicker from "vue2-daterange-picker";
import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
import moment from 'moment'

export default {
  components: { DateRangePicker },
  props: {
    isVisible: Boolean,
    resetValues: Boolean
  },
  data() {
    return {
      opens: "right",
      minDate: "2019-05-02", // needs discussing
      maxDate: moment().format('YYYY-MM-DD'),
      dateRange: {},
      single_range_picker: false,
      show_ranges: true,
      singleDatePicker: false,
      timePicker: true,
      timePicker24Hour: true,
      showDropdowns: true,
      autoApply: true,
      showWeekNumbers: true,
      linkedCalendars: true,
      alwaysShowCalendars: true,
      appendToBody: false,
      closeOnEsc: true,
    };
  },
  methods: {
    /* eslint-disable no-unused-vars */

    checkOpen (open) {
      this.$emit("updateWidth", !this.isVisible)
    },
    updateValues (values) {
      this.$emit("updateWidth", !this.isVisible)
      this.$emit('clicked',values)
    },
    /* eslint-disable no-unused-vars */
    toggleModal() {
      this.$emit("updateWidth", !this.isVisible)
      this.$refs.picker.togglePicker()
    }
  },watch: {
      resetValues: {
        handler() {
          // console.log(this.resetValues)
          this.dateRange = {}
        }
      }
    }
};
</script>
<style scoped>
.calendars {
  flex-wrap: unset !important;
  display: flex;
  align-items: flex-end;
}
.vue-daterange-picker[data-v-79d7c92a] {
  min-width: 0 !important;
}
</style>